export enum FLOW_TRIGGER_IDS {
    ABANDONED_CHECKOUT_IDENTIFICATION = 1,
    SALE_ANNOUNCEMENT = 2,
    NEW_PRODUCT = 3,
    COMPLEMENTARY_PRODUCTS = 4,
    ON_PURCHASE = 5,
    ON_NEW_SIGNUP = 6,
    AFTER_DELIVERY_ARRIVED = 7,
    ON_SHIPPING_ACKNOWLEDGED = 8,
    SHIPPING_ON_ITS_WAY = 9,
}